import { Alert, Alignment, Button, Dialog, FormGroup, HTMLTable, Tag, } from "@blueprintjs/core";
import { MDBCol, MDBRow, } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { ILogSefa, newEmpresa, } from "../../model";
import { IEmpresa } from "../../model";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { toast } from "react-toastify";
import { formatCnpj } from "../../utils";
import { EmpresaSelect, filterEmpresa, renderEmpresa, } from "../empresa/EmpresaSelect";
import { Pager } from "../utils/Pager";
import { SefaStore } from "../../stores/sefa/SefaStore";
import { sortBy } from "../../utils";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";
import { AppIcon } from "../utils/AppIcon";

interface Props {
  open: boolean
  onClose: () => void;
}

interface State { }

@observer
export class HistoricoSefa extends React.Component<Props, State> {

  obs = observable({
    open_logs: false as boolean,
    detalhes_page: 1 as number,
    agendamento_page: 1 as number,
    solicitacao_id: "" as string,
    loading: false as boolean,
    selectedEmpresaDetalhes: newEmpresa() as IEmpresa,
  })

  constructor(props) {
    super(props);
  }

  handleBuscaDetalhe = async (
    cnpj: string,
    filtro: string,
    date1: string,
    date2: string,
    sol_id: any,
    sefa_new: boolean
  ) => {

    this.obs.loading = true;

    await SefaStore.setBuscaProgramada(cnpj, filtro, date1, date2, sol_id, sefa_new);

    this.props.onClose()

    this.obs.open_logs = false
    SefaStore.obs.open_view_detalhes = false
    SefaStore.obs.detalhesSolicitacao = false;

    this.obs.loading = false;

  };

  handleLogsBotSEFA = async (id_solicitacoes: any, sefa_new: boolean) => {

    await SefaStore.buscaLogsBotSEFA(id_solicitacoes, sefa_new);

    if (SefaStore.obs.logs_robo.length > 0) {

      this.obs.open_logs = true;

    }

  };

  handleDetalhes = async (hist: any) => {

    let h = SefaStore.obs.historico.find(x => x.id == hist.id);

    this.obs.loading = true;
    this.obs.detalhes_page = 1;
    this.obs.selectedEmpresaDetalhes = newEmpresa()

    if (h.pendentes) {
      toast.warning('Nenhum detalhe para exibir, aguarde sua solicitaçãos ser processada.', {});

    } else {
      this.obs.solicitacao_id = hist.id;
      SefaStore.obs.solicitacao = [];

      await SefaStore.buscaDetalheSolicitacaoPaged(this.obs.solicitacao_id, 1, 6, "", hist.sefa_new);
      await SefaStore.length_detalhe(hist.id, hist.sefa_new);

    }

    this.obs.loading = false;

  };

  handlePageChangeDetalhes = async (page: number) => {

    this.obs.loading = true;

    this.obs.detalhes_page = page;

    this.obs.selectedEmpresaDetalhes = newEmpresa()

    await SefaStore.buscaDetalheSolicitacaoPaged(this.obs.solicitacao_id, page, 6, "", SefaStore.obs.solicitacao[0]?.sefa_new || false);

    this.obs.loading = false;

  };

  handlePageChangeAgendamento = async (page: number) => {

    await SefaStore.solicitacoesPaged(page, 7);

    this.obs.detalhes_page = page;

  };

  async handleFilterSolicitacoesEmpresa(empresa: any) {

    this.obs.loading = true;

    this.obs.selectedEmpresaDetalhes = empresa

    this.obs.detalhes_page = 1

    await SefaStore.buscaDetalheSolicitacaoPaged(this.obs.solicitacao_id, 1, 6, empresa.cnpj, SefaStore.obs.solicitacao[0]?.sefa_new || false);

    this.obs.loading = false;

  }

  async onClearEmpresa() {

    this.obs.loading = true;

    this.obs.selectedEmpresaDetalhes = newEmpresa()

    this.obs.detalhes_page = 1

    await SefaStore.buscaDetalheSolicitacaoPaged(this.obs.solicitacao_id, 1, 6, "", SefaStore.obs.solicitacao[0]?.sefa_new || false);

    this.obs.loading = false;

  }

  onCloseSolicitacoes() {

    this.props.onClose()

    this.obs.selectedEmpresaDetalhes = newEmpresa()

  }

  onCloseDetalhesSolicitacoes() {

    SefaStore.obs.detalhesSolicitacao = false

    this.obs.selectedEmpresaDetalhes = newEmpresa()

  }

  statusFormatter(sol, sefa_new, width) {

    return getTag(sol.status, sol.tipo, sol, width);

  }

  async handleErros(row: any) {

    let resp = await SefaStore.handleViewErros(row.id)

    SefaStore.obs.erros_sefa = [];

    if (!resp.length) {
      toast.info("Esta solicitação não possui erros.");
      return
    }

    SefaStore.obs.erros_sefa = resp;

    SefaStore.obs.open_erros_sefa = true;

  }

  render() {

    let empresaTextDetalhes = this.obs.selectedEmpresaDetalhes.razao_social != ""
      ? `${this.obs.selectedEmpresaDetalhes.razao_social} (${formatCnpj(this.obs.selectedEmpresaDetalhes.cnpj)})`
      : "Selecione uma empresa";

    let logs = SefaStore.obs.logs_robo?.map((sol, index) => {
      let empresa = EmpresaStore.getByCnpj(sol.cnpj);
      if (empresa) {
        return (
          <tr key={index} className="nz-table-actions">
            <td>
              {empresa.razao_social.substring(0, 30)}...
            </td>
            <td>
              {formatCnpj(sol.cnpj)}
            </td>
            <td>
              {sol.erro};
            </td>
          </tr>
        );
      } else {
        return false;
      }
    });

    function handleTipo(automatico) {
      switch (automatico) {
        case true:
          return <span className="new-tag-nav-new">Automático</span>
        default:
          return <span className="new-tag-nav">Manual</span>
      }
    }

    let historico = sortBy(SefaStore.obs.historico, "inserted_at").reverse()?.map(hist => {
      return (
        <tr key={hist.id} className="nz-table-actions">
          <td>
            {moment(hist.data_solicitacao).format("DD/MM/YYYY")}
          </td>
          <td>{moment(hist.date1).format("DD/MM/YYYY")}</td>
          <td>{moment(hist.date2).format("DD/MM/YYYY")}</td>
          <td>
            <b>{hist.total} selecionados</b>
          </td>
          <td>{handleTipo(hist.automatico)}</td>
          <td style={{ textAlign: "center" }}>
            <AppIcon size={22} name="error" style={{ color: "#c15151", cursor: "pointer" }} onClick={() => this.handleErros(hist)} />
          </td>
          <td style={{ textAlign: "center" }}>
            <AppIcon size={22} name="search" style={{ color: "#3579ea", cursor: "pointer" }} onClick={() => this.handleDetalhes(hist)} />
          </td>
          <td style={{ textAlign: "center" }}>
            <AppIcon size={22} name="list" style={{ color: "#166470", cursor: "pointer" }} onClick={() => this.handleLogsBotSEFA(hist.id, hist.sefa_new)} />
          </td>
        </tr>
      );
    });

    let detalhes = SefaStore.obs.solicitacao?.map(sol => {
      let empresa = EmpresaStore.getByCnpj(sol.cnpj);
      if (empresa) {
        return (
          <tr key={sol.id} className="nz-table-actions">
            <td>
              {empresa.razao_social.length >= 30 ? empresa.razao_social.substring(0, 30) + "..." : empresa.razao_social}
            </td>
            <td>
              {empresa.apelido ? empresa.apelido.length >= 30 ? empresa.apelido.substring(0, 30) + "..." : empresa.apelido : ""}
            </td>
            <td>
              {sol.cnpj ? formatCnpj(sol.cnpj) : ""}
            </td>
            <td>
              {moment(sol.date1).add({ "hours": 3 }).format("DD/MM/YYYY")} -{" "}
              {moment(sol.date2).add({ "hours": 3 }).format("DD/MM/YYYY")}
            </td>
            <td>
              {this.statusFormatter(sol, sol.sefa_new, { width: "100%" })}
            </td>
            <td>
              <Tag
                className="tagConfirmacao tagVerSolici"
                style={{ width: "100%", textAlign: "center" }}
                onClick={() => this.handleBuscaDetalhe(sol.cnpj, "Todos", moment(sol.date1).format("YYYY-MM-DD"), moment(sol.date2).format("YYYY-MM-DD"), sol.id, sol.sefa_new)}
              >
                Ver
              </Tag>
            </td>
            <td>
              <div style={{ cursor: "pointer" }} onClick={() => handleViewDetalhes(sol)}>
                <img src="/images/view.png" width="20px" />
              </div>
            </td>
          </tr>
        );
      } else {
        return null
      }
    }).filter(x => x != null)

    const handleViewDetalhes = async (row: ILogSefa) => {

      SefaStore.obs.view_detalhes = row;

      SefaStore.obs.log_erros = [];

      SefaStore.obs.log_erros = row.log_erros || [];

      SefaStore.obs.open_view_detalhes = true;

    };

    return (
      <div>

        <LoadingModal open={this.obs.loading} onClose={() => this.obs.loading = false} title={"Carregando"} />

        <Dialog
          usePortal={true}
          isOpen={this.props.open}
          onClose={() => this.props.onClose()}
        >
          <h2 className="titleSEFAZ">Histórico de Agendamento</h2>
          <div style={{ height: 400, overflow: "auto" }}>
            <HTMLTable className="table table-hover" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th style={{ width: 150 }}>Data da Solicitação</th>
                  <th style={{ width: 120 }}>Período Inicial</th>
                  <th style={{ width: 120 }}>Período Final</th>
                  <th style={{ width: 150 }}>CNPJs</th>
                  <th style={{ width: 80 }}>Tipo</th>
                  <th style={{ width: 80, textAlign: "center" }}>Erros</th>
                  <th style={{ width: 80, textAlign: "center" }}>Detalhes</th>
                  <th style={{ width: 80, textAlign: "center" }}>Logs</th>
                </tr>
              </thead>
              <tbody>
                {historico}
              </tbody>
            </HTMLTable>
          </div>

          <MDBRow>
            <MDBCol md="8" className="page-sefa">
              <div style={{ marginTop: 5 }}>
                <Pager
                  currentPage={this.obs.agendamento_page}
                  totalCount={SefaStore.obs.agendamento_length}
                  pageSize={7}
                  onPageChange={page => this.handlePageChangeAgendamento(this.obs.agendamento_page = page)}
                />
              </div>
            </MDBCol>
            <MDBCol md="4">
              <Button text="Fechar" onClick={() => this.onCloseSolicitacoes()} style={{ marginTop: "30px", float: "right" }} />
            </MDBCol>
          </MDBRow>
        </Dialog>

        <Dialog
          usePortal={true}
          isOpen={SefaStore.obs.detalhesSolicitacao}
          onClose={() => SefaStore.obs.detalhesSolicitacao = false}
        >
          <h2 className="titleSEFAZ">Detalhes da Solicitação</h2>

          <MDBRow>
            <MDBCol md="10">
              <FormGroup className="empresaSelect" label="Empresa">
                <EmpresaSelect
                  items={EmpresaStore.sortedEmpresas}
                  itemRenderer={renderEmpresa}
                  itemPredicate={filterEmpresa}
                  onItemSelect={(e: IEmpresa) => this.handleFilterSolicitacoesEmpresa(e)}
                  inputProps={{ placeholder: "Filtrar uma empresa" }}
                >
                  <Button
                    text={empresaTextDetalhes}
                    rightIcon="double-caret-vertical"
                    alignText={Alignment.LEFT}
                  />
                </EmpresaSelect>
              </FormGroup>
            </MDBCol>
            <MDBCol>
              <img src="/images/block.png" width={25} style={{ marginTop: 30, cursor: "pointer" }} onClick={() => this.onClearEmpresa()} />
            </MDBCol>
          </MDBRow>

          <div style={{ width: 1100, height: 350, overflow: "auto" }}>
            <HTMLTable className="table table-hover" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th style={{ width: 200 }}>Empresa</th>
                  <th style={{ width: 200 }}>Apelido</th>
                  <th style={{ width: 100 }}>CNPJ</th>
                  <th style={{ width: 130 }}>Período</th>
                  <th style={{ width: 100 }}>Status</th>
                  <th style={{ width: 70 }}>Detalhes</th>
                  <th style={{ width: 30 }}></th>
                </tr>
              </thead>
              <tbody>
                {detalhes}
              </tbody>
            </HTMLTable>
          </div>
          <MDBRow>
            <MDBCol md="8" className="page-sefa">
              <div style={{ marginTop: 5 }}>
                <Pager
                  currentPage={this.obs.detalhes_page}
                  totalCount={SefaStore.obs.detalhes_length}
                  pageSize={6}
                  onPageChange={page => this.handlePageChangeDetalhes(this.obs.detalhes_page = page)}
                />
              </div>
            </MDBCol>
            <MDBCol md="4">
              <Button text="Fechar" onClick={() => this.onCloseDetalhesSolicitacoes()} style={{ marginTop: "30px", float: "right" }} />
            </MDBCol>
          </MDBRow>
        </Dialog>

        <Alert
          confirmButtonText="Fechar"
          intent="warning"
          isOpen={this.obs.open_logs}
          onClose={() => this.obs.open_logs = false}
          canOutsideClickCancel={true}
        >
          <h2 className="titleSEFAZ">Histórico de Logs</h2>
          <div className="heightAuto">
            <HTMLTable className="table table-hover" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th style={{ width: 250 }}>Razão Social</th>
                  <th style={{ width: 150 }}>CNPJ</th>
                  <th style={{ width: 400 }}>ERRO</th>
                </tr>
              </thead>
              <tbody>
                {logs}
              </tbody>
            </HTMLTable>
          </div>
        </Alert>

      </div>
    );
  }
}

export default HistoricoSefa;
